import { useEffect, useState } from 'react';
import { useV2 } from './ctx';
import { jt, todayIso } from './model';

// Analisis › Perkiraan (Director, 19 Oct: "what needs forecasting is which
// truck gonna do what trip … based on how many days are left, current truck
// position and status, availability of routes"). Server: services/forecast.js.
// One row per truck from now to the end of the month: each loop is a dark
// pergi part and a light return part named after the load; the workshop is
// hatched. Below: the money those trips move, per day. Typical case drawn;
// the hero numbers carry the range (cepat–lambat).
const dec = (x, n = 0) => (x == null ? '—' : x.toLocaleString('id-ID', { minimumFractionDigits: n, maximumFractionDigits: n }));
const H = 3600e3, DAY = 864e5;
const wib = ms => new Date(ms + 7 * H);
const dayIso = ms => wib(ms).toISOString().slice(0, 10);
const PAYS = { lsj: 'lapak', eko: 'lapak', barokah: 'lapak', dody: 'lapak', aspex: 'can', pindo: 'can', cskind: 'can', waste: 'ikpt', kosong: 'none' };

export default function Perkiraan() {
  const { api, isPhone } = useV2();
  const mk = todayIso().slice(0, 7);
  const [f, setF] = useState(null);
  useEffect(() => { let live = true; const c = new AbortController(); api.forecast(mk, c.signal).then(r => live && setF(r)).catch(e => live && setF({ error: e.message })); return () => { live = false; c.abort(); }; }, [api, mk]);
  if (!f) return <p className="hint">Menghitung…</p>;
  if (f.error || !f.available) return <p className="hint bad">{f.error || f.reason}</p>;
  const monthLabel = new Date(mk + '-01T00:00:00').toLocaleDateString('id-ID', { month: 'long' });
  const endLabel = `${wib(f.monthEnd).getUTCDate()} ${monthLabel.slice(0, 3)}`;
  const t = f.totals, b = t.biasa;
  const pg = n => f.done.pergi + n, bl = n => f.done.balik + n;
  const cashIn = x => x.cash.lapak + x.cash.can;
  return (
    <>
      <div className="tri">
        <div className="hero"><span className="k">Rit pergi sampai {endLabel}</span><span className="v num">{pg(b.pergi)}</span><span className="s">sudah {f.done.pergi} · {b.pergi} lagi · kisaran {pg(t.lambat.pergi)}–{pg(t.cepat.pergi)}</span></div>
        <div className="hero"><span className="k">Balikan sampai {endLabel}</span><span className="v num">{bl(b.balik)}</span><span className="s">sudah {f.done.balik} · {b.balik} lagi · kisaran {bl(t.lambat.balik)}–{bl(t.cepat.balik)}</span></div>
        <div className="hero"><span className="k">UJ keluar sisa bulan</span><span className="v num">{jt(b.cash.uj)} jt</span><span className="s">masuk dari balikan {jt(cashIn(b))} jt · Indahkiat jadi piutang {jt(b.cash.piutang)} jt</span></div>
      </div>

      <section className="sec">
        <div className="sec-h"><div><h3>Siapa jalan apa, sampai {endLabel}</h3><p>dari posisi dan status GPS sekarang · perkiraan biasa</p></div></div>
        <Gantt f={f} isPhone={isPhone} />
        <div className="fc-legend"><span><i className="sw go" />pergi Serang → Lampung</span><span><i className="sw lapak" />balikan lapak (bayar tunai)</span><span><i className="sw can" />CSK (CAN)</span><span><i className="sw ikpt" />waste</span><span><i className="sw none" />kosong</span><span><i className="sw rep" />bengkel</span></div>
      </section>

      <section className="sec">
        <div className="sec-h"><div><h3>Uang dari perjalanan ini</h3><p>per hari, perkiraan biasa · UJ dibayar saat muat, lapak bayar saat muat, CAN ±2 hari setelah bongkar</p></div><span>juta</span></div>
        <CashDays f={f} isPhone={isPhone} />
      </section>

      <Assumptions a={f.assumptions} />
    </>
  );
}

// Timeline: now → month end. Each truck row lays its events on the same scale.
function Gantt({ f, isPhone }) {
  const t0 = f.now, t1 = f.monthEnd + 1, span = t1 - t0;
  const x = ms => `${Math.max(0, Math.min(1, (ms - t0) / span)) * 100}%`;
  const w = (a, z) => `${Math.max(0, (Math.min(z, t1) - Math.max(a, t0)) / span) * 100}%`;
  // day ticks at WIB midnight
  const ticks = [];
  for (let d = Date.parse(`${dayIso(t0)}T00:00:00+07:00`) + DAY; d < t1; d += DAY) ticks.push(d);
  const every = isPhone ? 3 : 1;
  return (
    <div className="fc-g">
      <div className="fc-row fc-head"><div className="fc-lab"><small className="fc-nowlab">sekarang →</small></div><div className="fc-track">
        {ticks.map((d, i) => { const dt = wib(d), we = [0, 6].includes(dt.getUTCDay()); return <span key={d} className={`fc-tick ${we ? 'we' : ''}`} style={{ left: x(d) }}>{i % every === 0 ? dt.getUTCDate() : ''}</span>; })}
      </div></div>
      {f.trucks.map(tr => (
        <div key={tr.no} className="fc-row">
          <div className="fc-lab"><b>{tr.no}</b><small className={tr.state === 'UNDER_REPAIR' ? 'bad' : ''}>{tr.status}</small></div>
          <div className="fc-track">
            {ticks.map(d => <span key={d} className="fc-grid" style={{ left: x(d) }} />)}
            {tr.plan.events.map((e, i) => {
              if (e.to <= t0 || e.from >= t1) return null;
              if (e.kind === 'repair') return <span key={i} className="fc-ev rep" style={{ left: x(e.from), width: w(e.from, e.to) }} title={`bengkel sampai ±${wib(e.to).getUTCDate()} ${new Date(e.to).toLocaleDateString('id-ID', { month: 'short' })}`}><em>bengkel</em></span>;
              const goEnd = e.from + 21 * H;
              const pays = PAYS[e.ret] || 'none';
              return (
                <span key={i} className="fc-loop" style={{ left: x(e.from), width: w(e.from, e.to) }} title={`${new Date(e.from).toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}: pergi, lalu ${e.label}`}>
                  <span className="fc-ev go" style={{ width: `${Math.max(0, Math.min(1, (goEnd - Math.max(e.from, t0)) / (Math.min(e.to, t1) - Math.max(e.from, t0)))) * 100}%` }} />
                  <span className={`fc-ev ${pays}`}><em>{e.label}</em></span>
                </span>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

// Per day: UJ out (down), cash in from returns (up). Indahkiat isn't cash this month.
function CashDays({ f, isPhone }) {
  const days = Object.keys(f.cash).sort();
  if (!days.length) return <p className="hint">Tidak ada perjalanan lagi bulan ini.</p>;
  const max = Math.max(...days.map(d => Math.max(f.cash[d].uj, f.cash[d].lapak + f.cash[d].can)), 1);
  const W = isPhone ? 340 : 760, Hh = 168, mid = 78, bw = Math.min(26, (W - 40) / days.length - 6);
  const sx = i => 30 + i * ((W - 40) / days.length) + 3;
  const s = v => (v / max) * 62;
  return (
    <div className="card" style={{ padding: '12px 12px 6px' }}>
      <svg viewBox={`0 0 ${W} ${Hh}`} width="100%" role="img" aria-label="Uang keluar dan masuk per hari">
        <line x1="26" x2={W - 6} y1={mid} y2={mid} stroke="var(--border)" />
        <text x="2" y={mid - 50} fontSize="10" fill="var(--muted)">masuk</text>
        <text x="2" y={mid + 58} fontSize="10" fill="var(--muted)">UJ</text>
        {days.map((d, i) => {
          const c = f.cash[d], inn = c.lapak + c.can;
          return (
            <g key={d}>
              {inn > 0 && <rect x={sx(i)} y={mid - s(inn)} width={bw} height={s(inn)} rx="2" fill="var(--green)" opacity=".75"><title>{`${d}: masuk ${jt(inn)} jt`}</title></rect>}
              {c.uj > 0 && <rect x={sx(i)} y={mid + 1} width={bw} height={s(c.uj)} rx="2" fill="var(--text)" opacity=".7"><title>{`${d}: UJ ${jt(c.uj)} jt`}</title></rect>}
              <text x={sx(i) + bw / 2} y={Hh - 2} fontSize="10" textAnchor="middle" fill="var(--muted)">{Number(d.slice(8))}</text>
            </g>
          );
        })}
      </svg>
      <div className="fc-cashsum">
        <span>UJ <b className="num">{jt(f.totals.biasa.cash.uj)} jt</b></span>
        <span>masuk dari lapak <b className="num pos">{jt(f.totals.biasa.cash.lapak)} jt</b></span>
        <span>dari CAN <b className="num pos">{jt(f.totals.biasa.cash.can)} jt</b></span>
        <span>bersih <b className="num bad">−{jt(f.totals.biasa.cash.uj - f.totals.biasa.cash.lapak - f.totals.biasa.cash.can)} jt</b></span>
      </div>
    </div>
  );
}

function Assumptions({ a }) {
  const L = a.length;
  const h2d = h => dec(h / 24, 1);
  return (
    <details className="fc-asm">
      <summary>Dasar perkiraan</summary>
      <ul>
        <li>Belum dihitung: koordinasi, ops lapangan dan perbaikan (akan masuk di langkah berikutnya, bersama tanggal kembali dari bengkel yang bisa diisi).</li>
        <li>Lama satu putaran (berangkat dari Indahkiat Serang sampai berangkat lagi), dari {a.loops} putaran GPS {a.days} hari terakhir: {['lsj', 'eko', 'barokah', 'dody', 'aspex', 'pindo', 'waste', 'kosong'].filter(k => L[k]?.p50).map(k => `${L[k].label} ${h2d(L[k].p50)} hari`).join(' · ')}.</li>
        <li>Balikan dipilih sesuai kebiasaan truk itu dan armada: {Object.entries(a.mix).filter(([, v]) => v > 0).map(([k, v]) => `${L[k]?.label || k} ${dec(v * 100)}%`).join(' · ')}.{a.unavailable.length > 0 && ` Tidak tersedia sekarang (app Ops): ${a.unavailable.join(', ')}.`}</li>
        <li>Truk di bengkel kembali setelah lama perbaikan biasa ({dec(a.repair.biasa, 1)} hari; lambat {dec(a.repair.lambat, 1)} hari), dihitung dari masuk bengkel.</li>
        <li>Uang: UJ pergi {jt(a.pergi.uj)} jt, pendapatan pergi rata-rata {jt(a.pergi.revenue)} jt per rit (faktur Accurate 2 bulan terakhir, dibayar Indahkiat ±36 hari kemudian). UJ dan bayaran balikan dari tabel rute app Ops.</li>
        <li>Kisaran: cepat = putaran dan perbaikan seperempat tercepat, lambat = seperempat terlama.</li>
      </ul>
    </details>
  );
}
